/*===================================================================
=       FILE READER                   =
====================================================================*/
/**
 * File Reader
 */

import { FileUrl } from "../components/molecule/FileListManager/FileListManager";
import { FileDtoIn } from "../types/files.types";

/**
 * 
 * @param url 
 * @returns 
 */
export const getDataFromUrlFile = (url: string)=>{
 return new Promise<string | ArrayBuffer | null>((resolve, reject) => {

    fetch(url).then((res) => {

       res.blob().then((blob) =>{
        let reader = new FileReader();
        reader.addEventListener(
         "load",
         () => {
             resolve(reader.result)
         },
         false,
       );
        reader.readAsDataURL(blob)

       }
       
       ).catch(
        (err) => {
            reject(err)
        }
       )



    }).catch(
        (err) => {
            reject(err+' \n File not found \n');
        }
       )

 }) 
}

export const convertFileToFileDto = (file: FileUrl[]): Promise<FileDtoIn[]> => {
    return new Promise<FileDtoIn[]>((resolve, reject) => {

        if(file.length === 0){
            resolve([])
        }
        let fileDtoIn: FileDtoIn[] = []
        file.forEach((f) => {
            const ignore = f.url === undefined ? false : true
            if(ignore){
                fileDtoIn.push({
                    filetype: f.type,
                    filename: f.name,
                    data_uri: "",
                    ignore: true
           
                })
                if (fileDtoIn.length === file.length) {
                    resolve(fileDtoIn)
                }
                
            }else{
                const reader = new FileReader();
                reader.onload = (e) => {
                    fileDtoIn.push({
                        filetype: f.type,
                        filename: f.name,
                        data_uri: e.target?.result as string,
               
                    })
                    if (fileDtoIn.length === file.length) {
                        resolve(fileDtoIn)
                    }
                }
                reader.readAsDataURL(f)
            }

        })
    }
    )
}